import { loadImg, roundRect, text, drawBackground, drawAvatar, drawBrand, drawCta, drawHeart } from "@/lib/badgeImage";
import { LAYOUTS, fitLines } from "@/lib/postImage";

const drawHeader = async (ctx, post, x, y, ar, story, maxW) => {
  const avatar = await loadImg(post.picture, true);
  drawAvatar(ctx, avatar, post.name, x + ar, y, ar);
  ctx.beginPath(); ctx.arc(x + ar, y, ar + 4, 0, Math.PI * 2); ctx.lineWidth = 4; ctx.strokeStyle = "#F9A8D4"; ctx.stroke();
  const tx = x + ar * 2 + 26;
  text(ctx, post.name, tx, y - 4, { size: story ? 42 : 32, weight: 800, color: "#1E1B1D", align: "left", maxW });
  text(ctx, "fragt die itzPlay Community", tx, y + (story ? 38 : 30), { size: story ? 28 : 22, weight: 600, font: "Plus Jakarta Sans", color: "#E11D48", align: "left", maxW });
};

const drawBar = (ctx, o, total, mine, x, y, w, h, story) => {
  const pct = total ? Math.round((o.votes / total) * 100) : 0;
  roundRect(ctx, x, y, w, h, h / 2); ctx.fillStyle = "#FDF2F8"; ctx.fill();
  if (pct > 0) {
    const g = ctx.createLinearGradient(x, 0, x + w, 0);
    g.addColorStop(0, mine ? "#FB923C" : "#FBCFE8"); g.addColorStop(1, mine ? "#EC4899" : "#F9A8D4");
    ctx.save(); roundRect(ctx, x, y, w, h, h / 2); ctx.clip();
    ctx.fillStyle = g; ctx.fillRect(x, y, Math.max(h, (w * pct) / 100), h); ctx.restore();
  }
  const size = story ? 34 : 26, ty = y + h / 2 + size * 0.36;
  const dark = mine && pct > 55;
  text(ctx, `${mine ? "✓ " : ""}${o.text}`, x + 30, ty, { size, weight: 800, color: dark ? "#fff" : "#1E1B1D", align: "left", maxW: w - 170 });
  text(ctx, `${pct}%`, x + w - 30, ty, { size, weight: 800, color: dark ? "#fff" : "#BE185D", align: "right" });
};

async function pollCard(ctx, L, post) {
  const { W } = L, story = L.H > L.W, x = 72, w = W - 144, pad = story ? 60 : 44;
  drawBackground(ctx, W, L.H);
  await drawBrand(ctx, W, L.brandY, L.scale);
  ctx.save(); ctx.shadowColor = "rgba(131,24,67,0.4)"; ctx.shadowBlur = 70; ctx.shadowOffsetY = 26;
  roundRect(ctx, x, L.top, w, L.bottom - L.top, 56); ctx.fillStyle = "#fff"; ctx.fill(); ctx.restore();
  const ar = story ? 48 : 34, hy = L.top + pad + ar, inner = w - pad * 2;
  await drawHeader(ctx, post, x + pad, hy, ar, story, inner - ar * 2 - 40);
  const opts = post.poll.options, gap = story ? 22 : 14, footH = story ? 90 : 60;
  const barH = Math.min(story ? 96 : 64, (L.bottom - pad - footH - (hy + ar + 200)) / opts.length - gap);
  const barsH = opts.length * (barH + gap) - gap, barsTop = L.bottom - pad - footH - barsH;
  const qTop = hy + ar + (story ? 46 : 28), qBot = barsTop - (story ? 40 : 22);
  const { size, lines } = fitLines(ctx, post.text || "", inner, qBot - qTop, story ? 76 : 54, story ? 40 : 30, 800, "Outfit");
  const lh = size * 1.28;
  let y = qTop + Math.max(0, (qBot - qTop - lines.length * lh) / 2) + size;
  lines.forEach((l) => { text(ctx, l, x + pad, y, { size, weight: 800, color: "#1E1B1D", align: "left", maxW: inner }); y += lh; });
  opts.forEach((o, i) => drawBar(ctx, o, post.poll.total, post.poll.my_vote === o.id, x + pad, barsTop + i * (barH + gap), inner, barH, story));
  const fy = L.bottom - pad / 2 - footH / 2 + (story ? 14 : 10);
  text(ctx, `${post.poll.total} Stimme${post.poll.total === 1 ? "" : "n"}`, x + pad, fy, { size: story ? 32 : 24, weight: 800, color: "#64748B", align: "left" });
  text(ctx, post.poll.closed ? "Ergebnis steht fest" : "Jetzt mit abstimmen →", x + w - pad, fy, { size: story ? 32 : 24, weight: 800, color: "#E11D48", align: "right" });
  const bx = x + w - 30, by = L.top - 10, br = story ? 64 : 48;
  ctx.save(); ctx.shadowColor = "rgba(131,24,67,0.35)"; ctx.shadowBlur = 30;
  ctx.beginPath(); ctx.arc(bx, by, br, 0, Math.PI * 2); ctx.fillStyle = "#fff"; ctx.fill(); ctx.restore();
  drawHeart(ctx, bx, by - br * 0.5, br * 1.05, "#F43F5E");
}

export async function renderPollImage({ post, code, format }) {
  await document.fonts?.ready;
  const L = LAYOUTS[format];
  const c = document.createElement("canvas");
  c.width = L.W; c.height = L.H;
  const ctx = c.getContext("2d");
  await pollCard(ctx, L, post);
  await drawCta(ctx, L.W, L.cardY, L.cardH, { code });
  return new Promise((resolve) => c.toBlob((bl) => resolve(bl), "image/png"));
}
